module.exports = __webpack_public_path__ + "img/3-5_Node_Select.801491e8.png";